import { useEffect, useState } from 'react';
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { authApi } from './api';

const r9Divisions = [
  { to: '/v3/home', name: '首页', icon: 'H', end: true },
  { to: '/v3/projects', name: '项目', icon: 'P', end: false },
  { to: '/v3/todo', name: '待我处理', icon: '待', end: true },
  { to: '/v3/settings', name: '设置', icon: '设', end: false },
];

function routeTitle(pathname: string): string {
  if (pathname === '/v3/home' || pathname === '/') return '首页';
  if (pathname === '/v3/todo') return '待我处理';
  if (pathname === '/v3/projects') return '项目';
  if (/^\/v3\/projects\/[^/]+\/deliverables/.test(pathname)) return '项目 · 交付物';
  if (/^\/v3\/projects\/[^/]+\/tasks/.test(pathname)) return '项目 · 任务';
  if (/^\/v3\/projects\/[^/]+\/activity/.test(pathname)) return '项目 · 活动记录';
  if (/^\/v3\/projects\//.test(pathname)) return '项目驾驶舱';
  if (pathname.startsWith('/v3/settings')) return '设置';
  if (pathname.startsWith('/v3/requirements')) return '新建需求';
  if (pathname.startsWith('/v3/plans')) return '方案';
  if (pathname.startsWith('/v3/acceptance')) return '验收';
  if (pathname.startsWith('/v3/progress')) return '执行进展';
  return '工作区';
}

export function App() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const title = routeTitle(pathname);

  // Resolve the currently-logged-in admin username.  We deliberately
  // surface ONLY the username and never the internal user id / password
  // hash.  The fetch is best-effort: if the session is gone the user is
  // bounced back to /login by AuthGuard on the next render.
  const [username, setUsername] = useState<string>('');
  useEffect(() => {
    let cancelled = false;
    authApi.me()
      .then((data) => { if (!cancelled) setUsername(data.username || ''); })
      .catch(() => { if (!cancelled) setUsername(''); });
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="dugongbu-shell">
      <aside className="dugongbu-sidebar">
        <NavLink to="/v3/home" className="brand-lockup" aria-label="杜工部 AI 工程管理系统">
          <span className="brand-mark">工</span>
          <span>
            <strong>杜工部</strong>
            <small>AI 工程管理系统</small>
          </span>
        </NavLink>

        <nav className="division-nav" aria-label="控制台导航">
          {r9Divisions.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => `division-link${isActive ? ' active' : ''}`}
            >
              <span className="division-icon">{item.icon}</span>
              <span>
                <strong>{item.name}</strong>
              </span>
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-sigil">当前工作区<br /><strong>项目推进与交付</strong></div>
      </aside>

      <div className="dugongbu-main">
        <header className="topbar">
          <div className="breadcrumb">
            杜工部 / <strong>{title}</strong>
          </div>
          <div className="topbar-actions" aria-label="系统状态">
            <span
              className="user-chip"
              data-testid="topbar-current-admin"
              title={username ? `当前登录账号：${username}` : '当前账号未识别'}
            >
              {username ? `管理员 · ${username}` : '管理员'}
            </span>
            <button
              className="ghost-button"
              onClick={() => void authApi.logout().then(() => navigate('/login', { replace: true }))}
            >
              退出登录
            </button>
          </div>
        </header>
        <main className="workspace">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
